import "./AiConfidenceModal.scss";

function polarToCart(cx, cy, r, angleDeg) {
  const rad = (angleDeg * Math.PI) / 180;
  return {
    x: cx + r * Math.cos(rad),
    y: cy - r * Math.sin(rad),
  };
}

function arcStroke(cx, cy, r, startAngle, endAngle) {
  const p1 = polarToCart(cx, cy, r, startAngle);
  const p2 = polarToCart(cx, cy, r, endAngle);
  return `M ${p1.x.toFixed(2)} ${p1.y.toFixed(2)} A ${r} ${r} 0 0 0 ${p2.x.toFixed(2)} ${p2.y.toFixed(2)}`;
}

export default function AiConfidenceModal({ open, onClose, onAddLogic, score = 6 }) {
  if (!open) return null;

  const cx  = 150;
  const cy  = 150;
  const r   = 112;
  const strokeW = 36;
  const maxScore = 10;

  // needle: 180° left → 0° right, score mapped linearly
  const needleAngle = (score / maxScore) * 180 - 90;
  const needleTip   = polarToCart(cx, cy, r - 28, needleAngle);

  // 6 segments × 30° = 180°.
  // Each path is 8° wide; with round caps (cap radius ≈ 18px ≈ 9° at r=112)
  // visual span ≈ 8+9+9 = 26° → ~4° gap between segments.
  const segments = [
    { start: 169, end: 161, color: "#c62828", minScore: 0    },
    { start: 139, end: 131, color: "#e64a19", minScore: 1.67 },
    { start: 109, end: 101, color: "#fb8c00", minScore: 3.33 },
    { start: 79,  end: 71,  color: "#fdd835", minScore: 5.0  },
    { start: 49,  end: 41,  color: "#8bc34a", minScore: 6.67 },
    { start: 19,  end: 11,  color: "#2e7d32", minScore: 8.33 },
  ];

  return (
    <div className="ai-modal-overlay" onClick={onClose}>
      <div className="ai-modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="ai-modal-close" onClick={onClose}>×</button>

        <svg viewBox="0 0 300 165" width="100%" style={{ display: "block" }}>

          {/* Arc segments */}
          {segments.map((seg, i) => (
            <path
              key={i}
              d={arcStroke(cx, cy, r, seg.start, seg.end)}
              fill="none"
              stroke={score > seg.minScore ? seg.color : "#252b45"}
              strokeWidth={strokeW}
              strokeLinecap="round"
            />
          ))}

          {/* Needle */}
          <line
            x1={cx}
            y1={cy}
            x2={needleTip.x.toFixed(2)}
            y2={needleTip.y.toFixed(2)}
            stroke="#ffffff"
            strokeWidth="2.5"
            strokeLinecap="round"
          />

          {/* Center pivot */}
          <circle cx={cx} cy={cy} r="5" fill="#1b2236" stroke="#ffffff" strokeWidth="2" />

          {/* Low / High */}
          <text x="6"   y={cy + 8} fill="#e53935" fontSize="12" fontWeight="700">Low</text>
          <text x="254" y={cy + 8} fill="#2e7d32" fontSize="12" fontWeight="700">High</text>
        </svg>

        <div className="ai-score-number">{String(score).padStart(2, "0")}</div>
        <div className="ai-score-label">Confidence Score</div>

        <button className="ai-add-logic-btn" onClick={onAddLogic}>
          + ADD LOGIC
        </button>
      </div>
    </div>
  );
}
